import React, { useState,useContext } from "react";
import AddCentre from "../components/Center/AddCentre";
import AllCentres from "../components/Center/AllCentres";
import UpdateCentre from "../components/Center/UpdateCentre";
import AuthContext from '../AuthContext'
function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
const authContext=useContext(AuthContext)
  const [updatePage, setUpdatePage] = useState(true);

  // Modal for Product ADD
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for Product UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        {/* Add Centre Modal */}
        {showProductModal && (authContext.userType!=='Accounts') && (
          <AddCentre 
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}
        
        {/* Update Centre Modal */}
        {showUpdateModal && (
          <UpdateCentre
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
          />
        )}
        
        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Training Centre</h2>
            {authContext.userType!=='Accounts' &&(
              <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
              onClick={addProductModalSetting}
            >
              Add Centre
            </button>
            )}
          </div>
          <AllCentres
            updateProductModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
